export default "__VITE_ASSET__7QsMvbat__"